'use client';

import { FC } from 'react';

import { AUSTRALIAN_STATES } from '@/constants/constants';

type Props = {
  loading: boolean;
  onInteract: () => void;
};

export const TradeInBannerFields: FC<Props> = ({ loading, onInteract }) => {
  return (
    <>
      <label htmlFor="rego" className="sr-only">
        Registration plate
      </label>
      <input
        type="text"
        name="rego"
        id="rego"
        placeholder="Type rego"
        data-testid="registration-plate"
        onClick={onInteract}
        className="h-13 w-2/3 p-2 text-center font-barlow text-[30px] uppercase outline-none"
        disabled={loading}
      />
      <label htmlFor="state" className="sr-only">
        State of registration
      </label>
      <select
        name="state"
        id="state"
        data-testid="state-of-registration"
        onClick={onInteract}
        className="h-13 w-1/3 border-l border-bor-neu-mut p-2 text-center outline-none"
        disabled={loading}
        defaultValue="NSW"
      >
        {AUSTRALIAN_STATES.map((state) => (
          <option key={state} value={state}>
            {state}
          </option>
        ))}
      </select>
    </>
  );
};
